import React from 'react';
import { connect } from 'react-redux';
import { clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { clickedNewGroup } from '../../../../actions/group';
import { showModal } from '../../../../actions/modal';

@connect()
export default class ViewAllRightTopPanel extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  showNewGroupModal = () => {
    clearAllValidationErrors();
    this.props.dispatch(showModal('.ui.modal.insert-group'));
    this.props.dispatch(clickedNewGroup());
  };

  render() {
    return (
      <div className="ui">
        <div>
          <button
            type="button"
            onClick={this.showNewGroupModal}
            className="ui labeled icon button color-button color-button-hover color-white max-width left-text mrbs"
          >
            <i className="add  icon" />
            {APP.LANGUAGE.ViewGroup.NewButton}
          </button>
        </div>
      </div>
    );
  }
}
